import { render, staticRenderFns } from "./PriceModel.vue?vue&type=template&id=11dc3194&scoped=true"
import script from "./PriceModel.vue?vue&type=script&lang=js"
export * from "./PriceModel.vue?vue&type=script&lang=js"
import style0 from "./PriceModel.vue?vue&type=style&index=0&id=11dc3194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc3194",
  null
  
)

export default component.exports